import { EventEmitter } from '@angular/core';
import { Component, Input, Output } from '@angular/core';

import { IJourneyBoard } from '../../interfaces/journey.interface';

@Component({
	selector: 'journey-board',
	templateUrl: './journey-board.component.html',
	styleUrls: ['./journey-board.component.scss'],
})
export class JourneyBoardComponent {
	@Input() therapy: IJourneyBoard[] = [];
	@Input() psychiatry: IJourneyBoard[] = [];
	@Input() contents: IJourneyBoard[] = [];
	@Input() evaluations: IJourneyBoard[] = [];

	@Output() goTo = new EventEmitter();
}
